"use client";

import { TIME_SLOTS } from "@/features/leads/shared/list-answers";
import { CheckRow } from "@/features/quote/ui/CheckRow";
import { StepHeading } from "@/features/quote/ui/StepHeading";
import { StepNav } from "@/features/quote/ui/StepNav";
import { useStep, useWizard } from "@/features/quote/ui/wizard-context";
import { toggled } from "@/shared/lib/list";

export function TimingStep() {
  const { next, back, canAdvance } = useWizard();
  const [{ timeSlots = [] }, answer] = useStep("timing");

  return (
    <section>
      {/* Wording is about time of day only - the preceding StartStep already
          asked when the job should be done, and two steps titled "hvornår"
          in a row read as the same question asked twice. */}
      <StepHeading
        title="Hvilket tidsrum må firmaet komme i?"
        body="Vælg et eller flere tidsrum - firmaerne matcher sig til det der passer jer bedst."
        maxW="max-w-[24ch]"
      />
      <CheckRow
        options={TIME_SLOTS.options}
        values={timeSlots}
        onToggle={(v) => answer({ timeSlots: toggled(timeSlots, v) })}
        cols={3}
      />
      <StepNav onBack={back} onNext={next} nextEnabled={canAdvance} nextLabel="Næste →" />
    </section>
  );
}
